// Inline error-state resolver — the same i18n fallback chain as
// showErrorToast (lib/error-toast.ts) but resolved to plain strings for
// in-layout <ErrorState> rendering instead of a transient toast. Screens
// that render a query error inside the page body (B2 ops screens) use
// this so a backend envelope error always lands as a localized title +
// description pair:
//
//   errors.code.<code> → errors.classification.<class>.fallback
//                      → errors.unknown.fallback

import type { TFunction } from "i18next";

import { mapErrorToToast } from "@/lib/error-toast";

export interface ErrorDisplay {
  readonly title: string;
  readonly description: string;
}

export function resolveErrorDisplay(error: unknown, t: TFunction): ErrorDisplay {
  const descriptor = mapErrorToToast(error);
  const classFallbackKey =
    descriptor.classification !== undefined
      ? `errors.classification.${descriptor.classification}.fallback`
      : "errors.unknown.fallback";

  return {
    title: t(descriptor.titleKey, { defaultValue: t("errors.unknown.title") }),
    description: t(descriptor.messageKey, {
      defaultValue: t(classFallbackKey, {
        defaultValue: t("errors.unknown.fallback"),
      }),
    }),
  };
}
